import { useTran } from "@/hooks";
import { Card } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { InputField, SelectField } from "@/components/common";
import { SURVEY_STATUSES, SURVEY_TYPES } from "../utils/survey-manager.helper";

const SurveyFormCard = ({ form = {}, errors = {}, onFieldChange }) => {
  const { t } = useTran();

  return (
    <Card className="space-y-1 border border-border bg-card p-5 shadow-sm">
      {/* Header */}
      <div>
        <p className="text-sm font-semibold text-foreground">{t("Survey")}</p>
        <p className="text-xs text-muted-foreground">
          {t("Define survey details and respondent scope.")}
        </p>
      </div>

      {/* Title */}
      <InputField
        label={t("Survey Title")}
        labelClassName="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
        placeholder={t("Enter survey title")}
        value={form.title ?? ""}
        onChange={(e) => onFieldChange?.("title", e.target.value)}
        error={errors.title}
      />

      {/* Description */}
      <div className="space-y-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {t("Description")}
        </label>
        <Textarea
          placeholder={t("Optional description")}
          value={form.description ?? ""}
          onChange={(e) => onFieldChange?.("description", e.target.value)}
        />
      </div>

      <SelectField
        label={t("Type")}
        labelClassName="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
        options={SURVEY_TYPES}
        value={form.type ?? ""}
        onChange={(e) => onFieldChange?.("type", e.target.value)}
        placeholder={t("Select type")}
        error={errors.type}
      />

      <SelectField
        label={t("Status")}
        labelClassName="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
        options={SURVEY_STATUSES}
        value={form.status ?? ""}
        onChange={(e) => onFieldChange?.("status", e.target.value)}
        placeholder={t("Select status")}
        error={errors.status}
      />

      {/* Expires At */}
      <InputField
        label={t("Expires at")}
        labelClassName="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
        type="date"
        value={form.expiresAt ?? ""}
        onChange={(e) => onFieldChange?.("expiresAt", e.target.value)}
        min={new Date().toISOString().split("T")[0]}
        error={errors.expiresAt}
      />
    </Card>
  );
};

export default SurveyFormCard;
